import { fetchEndpoint } from '../server/network';

// 文章列表
export const articleList =
(id, page, per_page) =>
fetchEndpoint(
  '/v2/ecapi.article.list',
  'POST',
  {
    "id": id,  // 文章ID
    "page": page,  // 当前第几页
    "per_page": per_page,  // 每页多少
  }
)

// 分类列表
export const cateArticleList = (id, page, per_page) =>
    fetchEndpoint('/v2/ecapi.article.cate.list', 'POST', {
      id: id, // 文章ID
      cat_type: 1,  //文章分类
      page: page, // 当前第几页
      per_page: per_page // 每页多少
    })

// 分类及文章列表
export const catArticleAllList = (id, page, per_page) =>
    fetchEndpoint('/v2/ecapi.article.cat.alllist', 'POST', {
      id: id, // 文章ID
      cat_type: 1,  //文章分类
      page: page, // 当前第几页
      per_page: per_page // 每页多少
    })

// 帮助分类列表
export const catHelpList = (id, page, per_page) =>
    fetchEndpoint('/v2/ecapi.article.cate.list', 'POST', {
      id: id, // 文章ID
      cat_type: 5, // 帮助分类
      page: page, // 当前第几页
      per_page: per_page // 每页多少
    })




// WEBPACK FOOTER //
// ./src/api/article.js